import styled from '@emotion/styled';

const StyledNumberButton = styled.button<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background-color: ${({ active }) =>
    active ? 'rgba(0, 102, 204, 0.10)' : ''};
  &:disabled {
    cursor: not-allowed;
    pointer-events: none;
    font-weight: 100;
  }
  &:hover {
    background-color: ${({ active }) => (active ? '' : '#e7e9ec')};
  }
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
`;

const PageLayout = styled.div`
  display: flex;
  border-radius: 4px;
  background-color: #f9fafb;
  padding: 4px;
  gap: 2px;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  gap: 24px;
  border-radius: 8px;
  border: 1px solid #e7e9ec;
  background: #fff;
  box-shadow: 0 16px 32px 0 rgba(0, 0, 0, 0.08);

  &.isFixed {
    position: fixed;
    bottom: 56px;
  }
`;

const StyledArrowButton = styled.button<{ active: boolean }>`
  padding: 4px;
  border-radius: 4px;
  background: #f9fafb;
  pointer-events: ${({ active }) => (active ? 'auto' : 'none')};
  &:hover {
    background-color: #e7e9ec;
  }
  &:disabled {
    cursor: not-allowed;
    pointer-events: none;
  }
  > svg {
    vertical-align: middle;
    path {
      stroke: ${({ active }) =>
        active ? 'black !important' : '#D1D8E2 !important'};
    }
  }
`;

const StyledInput = styled.input<{ isError: boolean }>`
  height: 32px;
  width: 42px;
  padding: 8px 4px;
  border-radius: 4px;
  border: ${({ isError }) =>
    isError ? '1px solid #F55060 !important' : '1px solid #E7E9EC'};
  box-sizing: border-box;
  text-align: center;
  &:hover {
    border: 1px solid black;
  }
  &::placeholder {
    color: #d4d7db; /* 원하는 색상으로 변경 */
  }
  &:focus {
    outline: none; /* 기본 브라우저 outline 제거 */
    border-color: black; /* 원하는 테두리 색상 */
  }
`;
const InputWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const ErrorTooltip = styled.div`
  position: absolute;
  top: -45px;
  left: -135px;
  background-color: white;
  color: #f55060;
  padding: 8px 12px;
  font-size: 12px;
  border-radius: 8px;
  white-space: nowrap;
  z-index: 10;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.08);
`;

const ErrorArrow = styled.div`
  position: absolute;
  bottom: -6px;
  left: 150px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid white;
`;

export {
  StyledArrowButton,
  StyledNumberButton,
  PageLayout,
  Container,
  StyledInput,
  InputWrapper,
  ErrorTooltip,
  ErrorArrow,
};
